import ConfirmPopover from '@/components/common/ConfirmPopover';
import { useApplication } from '@/hooks/useApplication';
import { useTreeContextMenu } from '@/hooks/useTreeContextMenu';
import { deletePromptGroup } from '@/util/delete';
import { dismissOnContextMenu } from '@/util/menu';
import { AddToPhotos, Clear, Edit } from '@mui/icons-material';
import MoveDownIcon from '@mui/icons-material/MoveDown';
import { ListItemIcon, Menu, MenuItem } from '@mui/material';
import React, { FC } from 'react';

export type PromptsTreeItemsWrapperProps = {
  children: React.ReactNode;
  id?: number;
  openNewDialog: () => void;
  openAddDialog: (id: number) => void;
  openEditDialog: (id: number) => void;
};

const PromptsContextMenuWrapper: FC<PromptsTreeItemsWrapperProps> = (props) => {
  const { application, setApplication } = useApplication();
  const { contextMenu, handleContextMenu, handleClose } = useTreeContextMenu();

  const handleDelete = () => {
    if (!props.id) return;
    const updatedApplication = deletePromptGroup({ ...application }, props.id);
    setApplication(updatedApplication);
    handleClose();
  };

  return (
    <div onContextMenu={handleContextMenu}>
      {props.children}
      <Menu
        open={contextMenu !== null}
        onClose={handleClose}
        anchorReference='anchorPosition'
        anchorPosition={contextMenu !== null ? { top: contextMenu.mouseY, left: contextMenu.mouseX } : undefined}
        slotProps={dismissOnContextMenu(handleClose)}
      >
        <MenuItem
          onClick={(e) => {
            props.openNewDialog && props.openNewDialog();
            handleClose();
          }}
        >
          <ListItemIcon>
            <MoveDownIcon fontSize='small' />
          </ListItemIcon>
          New prompt group...
        </MenuItem>
        {props.id && (
          <MenuItem
            onClick={() => {
              props.openAddDialog && props.id && props.openAddDialog(props.id);
              handleClose();
            }}
          >
            <ListItemIcon>
              <AddToPhotos fontSize='small' />
            </ListItemIcon>
            Add prompts to group
          </MenuItem>
        )}
        {props.id && (
          <MenuItem
            onClick={() => {
              props.openEditDialog && props.id && props.openEditDialog(props.id);
              handleClose();
            }}
          >
            <ListItemIcon>
              <Edit fontSize='small' />
            </ListItemIcon>
            Edit group
          </MenuItem>
        )}
        {props.id && (
          <ConfirmPopover
            component='MenuItem'
            onConfirm={handleDelete}
            icon={<Clear />}
            buttonText='Delete prompt group'
            text={`Remove ${application?.promptGroups?.find((promptGroup) => promptGroup.id === props.id)?.name}`}
          />
        )}
      </Menu>
    </div>
  );
};

export default PromptsContextMenuWrapper;
